/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Col_ProductInputs */

const vi_receipt_col_product = /** @type {(inputs: Receipt_Col_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm`)
};

/**

* @param {Receipt_Col_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_col_product = /** @type {((inputs?: Receipt_Col_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Col_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_col_product(inputs)
});